<template>
	<v-card 
		outlined 
		height 		= "100%" 
		color  		= "black" 
		ref    		= "card"
		:max-height = "max_height" 
	>
		<v-card-title 
			class = "pa-0  px-1 body-1 secondary vue-draggable-handle white--text" 
		>
			<span 
				v-text = "$ml.get('analytics_logs')"
			></span>
			<v-chip 
				x-small 
				color = "success"
				class = "mx-2 text-uppercase"
			> 
				{{ title }}  
			</v-chip>
			<v-chip 
				x-small 
				color  = ""
				class  = "mx-3 text-uppercase"
				v-show = "info_action.action"
			> 
				{{ info_action.action }}  
			</v-chip>
			
			<v-spacer></v-spacer>
			
			<v-tooltip
		        top   
		        v-model = "status.tooltip"     
		    >
		        <template v-slot:activator="{ on }">                  
		          	<v-icon 
		            	x-small 
		            	v-on   = "on" 
		            	:color = "status.color"
		            	class  = "mx-2"
		            	v-show = "false"
		          	>
		          		mdi-circle
		          	</v-icon>
		        </template>
		        <span> 
		          {{ $ml.get('status') }}: {{status.message}}
		        </span>
		    </v-tooltip>
			<v-btn-toggle
				dense
				v-show = "show_options"
				
			>
				<template
					v-for = "(item_opt, item_opt_index) of options_alts"
					v-if  = "item_opt.enable "
				>
					<v-tooltip bottom>
						<template v-slot:activator="{ on }">
							<v-btn								
								x-small
								:key 	= "item_opt_index"
								class 	= "pa-0"
								:color 	= "item_opt.color"
								v-on 	= "on"
								@click 	= "actions_setting(
									{ 
										option: item_opt.action, // option Analytic
										// name  : item_option.key // analytic
									})"											
								
							>
								<v-icon
									v-show = "item_opt.icon "
									x-small
								>
									{{ item_opt.icon }}
								</v-icon>
							</v-btn>
						</template>
						<span>
							{{ item_opt.text }}
						</span>
					</v-tooltip>

				</template>
			</v-btn-toggle>
			<v-tooltip bottom>
				<template v-slot:activator="{ on }">
					<v-icon
						small
						color  = "error"
						class  = "mx-2"
						@click = "clear_log"
						v-on   = "on"
					>
						mdi-delete-sweep
					</v-icon>
				</template>
				<span>
					{{ $ml.get('clear_logs') }}
				</span>
			</v-tooltip>
			

			<!-- <v-menu offset-y>
		      <template v-slot:activator="{ on: menu, attrs }">
		      	<v-tooltip top>
		      		<template v-slot:activator="{ on: tooltip}">
		      			
				        <v-btn
				        	x-small
					        color="primary"
					        dark
					        v-bind="attrs"
					        v-on="{ ...tooltip, ...menu }"
					        class="mr-2"
				        >
				          <v-icon
				          	x-small
				          	v-text="'mdi-filter-menu'"
				          ></v-icon>

				        </v-btn>
		      		</template>
		      		<span>
		      			Select Analytic
		      			
		      		</span>
		      	</v-tooltip>
		      </template>
		      <v-list dense>
		      	<v-list-item
		          	v-for="(item, index) of list"
		          	:key="index"
		          	@click="select=item"
		          	dense
		        >
		          <v-list-item-title>{{ item.containerId }}</v-list-item-title>
		        </v-list-item>
		      </v-list>
		    </v-menu> -->
		</v-card-title>
		<v-card-text
			id 		= "scroll-target-1"
		    class 	= "overflow-y-auto no-drag"
		    :style 	= "{'height': height + 'px'}"
		    
		>	
		    <!-- max :height="height+'px'" -->
			<div
				v-scroll:#scroll-target-1 = "onScroll"
		        align 	= "left"
		        justify = "left"
		        :height = " height  + 'px'"
			>
		        <!-- + 20 / style="height: 300px" -->
				<template
					
					v-for = "(item_log, index_log) of logs "
				>
					<span 
						:key 	= "index_log"
						:class 	= "`${item_log.color}--text`"
					> <!-- {{  logs.length - index_log }} -->  
						
						{{ item_log.msg }}
					</span><br>
				</template>
			</div>
		</v-card-text>
	</v-card>
</template>
<script>
	import EventBus 		  from '@/event-bus'
	import options_analytics  from '@/components/analytics/options_analytics.json'
	export default{
		name: 'analytics_logs',
		props:[ 
			'info_logs',
			'layout',
			'layout_id',
			'max_height',
		], // props
		data:() => ({
			logs 	  	: [],
			offsetTop 	: 0,
			height 	 	: 250,
			select 	 	: {},
			list 		: [],
			select 		:  null,
			duration 	: 300,
			type 		: 'number',
        	number 		: 9999,
        	easing 		: 'easeInOutCubic',
        	offset 		: 0,
        	timer_cancel : null,
        	options_alts : options_analytics.options,
        	show_options : false,
        	title 		 : 'motion', 
        	status 		 : {
        		color   : 'grey darken-2',
        		message : 'inactive',
        		tooltip : false,
        	},
        	info_action : {
        		action 		: '', 	
				active_logs : false,
			},
			bus 		: {},
			info_item   : {},
			ID_notification : 'analytics_logs',
		}), // data

		created(){
			if (this.$route.name == 'setting_analytic') {
				this.show_options = true;
				if (this.options_alts && this.options_alts.length > 0) {
					let idx_setts = this.options_alts.findIndex( x => x.text == 'settings');
					if (idx_setts >= 0) {
						this.options_alts[idx_setts].enable = false; 
					}
					let idx_opts = this.options_alts.findIndex( x => x.text == 'options');
					if (idx_opts >= 0) {
						this.options_alts[idx_opts].enable = false; 

					}
				}
			}
			if (this.info_logs) {
				this.render_list();
			}

		}, // created

		watch:{
			layout:function(v){
				this.onResize();
			}, //layout
			
			info_logs: function (val){
				if (val) {
					this.render_list();
				}
			}, // info_logs
		}, // watch	

		methods: {
	      	onScroll (e) {
	      		// console.log("target ****************", e.target)	      			      		
	        	this.offsetTop = e.target.scrollTop;

	     	}, // onScroll

	     	onResize() {
				// console.log(this.height, this.$refs, '	analytics_logs')
				this.height = this.$refs.card.$el.clientHeight - 40 ;// 130 this.$refs.card.clientHeight-100;					
				
			}, //on Resize

			render_list(){
				let list_temp = this.info_logs && this.info_logs.container && this.info_logs.container.length > 0 ? this.info_logs.container : null,
					new_list = [];
				// console.log('render analytics_logs', this.info_logs);
				console.log("CREATE LOGS ",  list_temp)
				if (list_temp && list_temp.length > 0) {

					/*list_temp.forEach( function ( item_container, idx_container){
						if (item_container) {
							new_list.push(item_container);
						}
					}) */


					this.list = list_temp;
					// if (new_list && new_list.length > 0) {
						// this.select = list_temp[0];
						// 1d10d56e3515f78a2d92528a5bf20d0d8189dc1be38bbe6a084b31bcc97b1e56
					// }
				}

			}, // render list

			clear_log(){
				this.logs = [];
			}, // clear log

			actions_setting(act){
				let item = this.info_logs;
				
				EventBus.$emit('action_analytic', {
					action : act.option,
					item
				});

				if (act.option == 'log') {
						EventBus.$emit('select_log_container', item);
						// EventBus.$emit('set_ref_events', act.name);
				}
				if (act.option == 'start') {

					this.action_container('start', item);
					EventBus.$emit('select_log_container', item);
					// EventBus.$emit('set_ref_events', act.name);
				}
				if (act.option == 'stop') {
					this.action_container('stop', item);
				}
				if (act.option == 'confirm_upgrade') {
					this.info_item = {
						action : { option : 'upgrade' },
						item,
						act
					};
					EventBus.$emit('notifications_modal', {
						type : 'confirm_upgrade',
						ID   : this.ID_notification 
					})

				}
				if (act.option == 'upgrade') {
					console.log("upgrade");
					this.action_container('upgrade', item);
				}

				if (act.option == 'restart') {
					console.log(act.option);
					this.action_container(act.option, item);	
				}
			}, // actions settings

			action_container(act, item){
				if (!this.$store.getters["auth/permission"]( this.$route.name, "can_edit")) {
					this.$EventBus.$emit("notifications_modal",{
						type 	: "warning",
						message : this.$ml.get("no_have_permission_edit") + " : " + this.$ml.get(this.$route.name),
					})						
					return false;
				}
				console.log("Action container ", act);
				if (act == 'restart') {
					if (this.$route.name == 'setting_analytic') {

						this.$EventBus.$emit('loading_setting_analytic', true);
					}
				}
				if (item && item.idContainer) {
					let info_send = null;
					const api 	  = this.$URL + '/api/v1/container/' + item.idContainer + '/'+act;
					this.$axios.post(api).then( res =>{
						console.log( "res action container ", act, res);
						info_send = res && res.data ? res.data : res;
						EventBus.$emit('action_analytic', {
							message : info_send
						});
						if (act == 'restart') {
							this.$EventBus.$emit('notifications_modal', {
								type  	: 'success',
								message : this.$ml.get('restarted') + ' : ' + this.$ml.get('analytic') 
							})	
							if (this.$route.name == 'setting_analytic') {
									this.$EventBus.$emit('loading_setting_analytic', false);
							}
						}
					}).catch( er => {
						info_send = er && er.message ? er.message : er;

						EventBus.$emit('action_analytic', {
							message : { msj : info_send }
						});
						EventBus.$emit('action_analytic', {
							message : { msj : "Error request" }
						});
						console.log("Error action container ", act, er);
					})
				}
			}, // action container

			render_status(item){
	     		if (item) {
	     			let ID = item.Id,
	     				state = false,
	     				vm = this; 
	     			if (item.State) {
	     				state = item.State.Running;
	     			}	     	

	     			if (this.select && this.select.idContainer === ID){
	     				
	     				let msj = '';
	     				this.status.tooltip = true;
	     				if (state) {
	     					this.status.message = 'active';
	     					this.status.color   = 'success';
	     				}else{
	     					this.status.message = 'inactive';
	     					this.status.color   = 'grey darken-2';
	     				}

	     				EventBus.$emit('action_analytic', {
							action : 'Container status: ' + this.status.message,
							color  : state ? 'success' : 'secondary',
						});
	     				const timer = setTimeout(()=>{
	     					this.status.tooltip = false;
	     					clearTimeout(timer);
	     				}, 1500);

	     				// console.log("change state analytics : ", idx)
	     			}else{
	     				
	     				console.log("Not found container to show status : ", this.select);
	     			}
	     		}// item

	     	}, // render status

	    }, // methods

	    computed : {
	    	/*target () {
		        const value = this[this.type]
		        if (!isNaN(value)) return Number(value)
		        else return value
	      	},
	      	*/
	      	options () {
	        	return {
		          duration : this.duration,
		          offset   : 500,//this.offsetTop,
		          easing   : this.easing,
		        }
	      	},
	    }, // computed

		mounted(){
			let vm 		= this;
			this.height = 250;

			vm.$nextTick( ()=>{
				vm.onResize();

			})

				
			/*const timer = setTimeout(function() {
				console.log("START LOGS Analytics ***************************************", vm.select);
				 if (vm.select){
						EventBus.$emit('start_logs_container', vm.select);
				 }
				clearTimeout(timer);
			}, 3000);*/

			let num = 0
			let d = document.getElementById("scroll-target-1");
			
			this.$nextTick(()=>{
				d.scrollTop = 99999;
			})
			let temp_noti 	  = 'notifications_modal' + this.ID_notification;
			EventBus.$on(temp_noti, vm.bus[temp_noti] = (action) => {
				if (action) {
					if (this.info_item) {

						let { action , item, act } = this.info_item;

						this.actions_setting(action, item, act)
					}else{
						console.log("Not found info to delete in analytics ");
					}
				}else{
					this.info_item = {};
				}
			});

			EventBus.$on("select_log_container", vm.bus.select_log_container = (action)=>{
				if (action && this.$store.getters["auth/permission"]( this.$route.name, "can_edit")) {					
					console.log("start log container", action);
					this.select = action;
					if (action.type) {
						this.title = action.type;
					}
					d.scrollTop = 99999;
					EventBus.$emit('start_logs_container', action);
					vm.logs.push({ 
						msg   : " Loading logs...", 
						color : 'success'
					});
					vm.timer_cancel = setTimeout(() => {
						vm.logs.push({ 
							msg 	: "Waiting logs... ", 
							color 	: 'warning'
						});
						d.scrollTop = 99999;
						clearTimeout(vm.timer_cancel);
						vm.timer_cancel = null;						
					}, 10000);
				}
			});		
			let contt = 0;
			EventBus.$on('action_analytic_req',vm.bus.action_analytic_req = (msg) =>{
				console.log("action_analytic_req num cont : ", contt)
				contt++
				if (msg) {
					let color = 'success';
					if (msg.action == 'restart') {
						color = 'primary';
					}
					this.actions_setting({
						option : msg.action
					});
					EventBus.$emit('action_analytic', {
						action : msg.action,
						color
					});
				
				}
			});
			EventBus.$on('action_analytic', vm.bus.action_analytic = (msg) =>{
				if (msg) {
					let color = '';
					if (msg.action) {
						color  	= msg.color ? msg.color : 'success';
						if (msg.action == 'stop') {
							vm.info_action.active_logs = false;
							vm.info_action.action = msg.action; 
						}else if(['start', 'log'].includes(msg.action)){
							vm.info_action.active_logs = true;
							vm.info_action.action = msg.action; 
						}else if(msg.action == 'restart'){
							vm.info_action.active_logs = true;
							vm.info_action.action = msg.action; 
						}
						vm.logs.push( { 
							msg : 'action : ' + msg.action,
							color
						});
					}
					if (msg.item) { // if its container
						this.select = msg.item;
					}
					if (msg.message) {
						let mssg =  '' ; /*&& msg.message.data ? msg.message.data : msg.message;*/
						// console.log("RES LOGS : ", mssg)
						if (msg.message) {
							if (msg.message.msj) {
								mssg = msg.message.msj;
							}
							if (msg.message.data) {
								if (msg.message.data.reason) {
									mssg = msg.message.data.reason
									if (msg.message.data.reason.msj) {
										mssg = msg.message.data.reason.msj;
									}
								}
							}

						}
						vm.logs.push({ 
							msg: mssg, 
						});	
					}
				}
				d.scrollTop = 99999;
			});

			EventBus.$on('log_events', vm.bus.log_events = (msg) =>{
				let log =  msg ;
				// console.log("logss ")
				if (vm.timer_cancel) {
					clearTimeout(vm.timer_cancel);
					vm.timer_cancel = null;
				}
				if (vm.info_action.active_logs) {
					vm.logs.push({ msg : log });
				}
				// vm.offset++;
				d.scrollTop = 99999
				if (vm.logs.length > 200) {
					vm.logs.shift();
				}
			})

			EventBus.$on('status_container', vm.bus.status_container = (action)=>{
				if (action) {
					this.render_status(action);
				}
			});


			/*
				btn: start, restart, stop, 
				analitics main: motion


				  "name":"237",
				    "rstp":"rtsp://Admin:ebenezer890@193.178.3.37/stream2",
				    "xaddr":"a",
				    "user":"admin",
				    "password":"password"
			*/
		}, // mounted

		beforeDestroy(){
			console.log("Close container : ", this.select);
			EventBus.$emit('close_logs_container', this.select);
			if (this.options_alts && this.options_alts.length > 0) {
				let idx_setts = this.options_alts.findIndex( x => x.text == 'settings');
				if (idx_setts >= 0) {
					this.options_alts[idx_setts].enable = true; 
				}
				let idx_opts = this.options_alts.findIndex( x => x.text == 'options');
				if (idx_opts >= 0) {
					this.options_alts[idx_opts].enable = true; 
					
				}
			}
			let vm = this;
			if (vm.bus) {
				console.log("close bus logs", vm.bus);
				for(let iter in vm.bus){
					if (vm.bus[iter]) {
						EventBus.$off(iter, vm.bus[iter]);						
					}
				}
			}
		}
	}; // export default
</script>
